import './ProjectSection.css';
import ProjectBlock from './ProjectBlock.js';
import projectPillar from './projectPillar.svg'
import React from "react";

function ProjectSection(props) {
    return (
        <div className="projectSection">
            <p className="projectSectionHeaderText"> my projects</p>
            <div className="projectPillars">
                {props.userProfile.projects.map((project, index) => (
                    <ProjectBlock key={index} unstyled={false} title={project.shortName} color={project.backgroundColor} position={index+1} />
                ))}
            </div>
            <img className="projectPillar" src={projectPillar} alt="black outline illustration of a fancy top of a marble structure - with individual stones representing projects"></img>
        </div>
    )
}

export default ProjectSection;